<template>
  <div>
    {{ StoreLangTranslation.data[d_approveInfoType][StoreLang] }}
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { data as phone_area_code_list } from '@/wam/options/phone_area_code_list';
import { data as lang_list } from '@/wam/options/lang_list';
import store from '@/store';
import { WisdomRegex } from '@/public/WisdomRegex';
import { mapGetters } from 'vuex';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as Modal
} from '@/components/widgets/Modal';
export default {
  name: 'campaignmail_unsubscribe',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreUser: 'StoreUser',
    StoreLoading: 'StoreLoading',
    StoreModal: 'StoreModal',
    StoreLang: 'StoreLang',
    StoreCurrencyType: 'StoreCurrencyType',
    StoreCurrencyTypeList: 'StoreCurrencyTypeList',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreFrontendWebsiteunit: 'StoreFrontendWebsiteunit',
    StoreMenuData: 'StoreMenuData',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreShopCartList: 'StoreShopCartList',
    StoreShopCartOrderList: 'StoreShopCartOrderList',
  }),
  data () {
    return {
      d_approveInfoType: 'unsubscribe_waiting',
      d_queryUnsubscribeCode: '',
    };
  },
  created: function () {
    if (this.$route.query.cl) {
      this.d_queryUnsubscribeCode = this.$route.query.cl;
    }
    if (this.d_queryUnsubscribeCode) {
      this.f_unsubscribe();
    }
  },
  mounted: function () {
    if (this.$router.currentRoute.query.promocode) {
      this.f_fillUriPromocode();
    }
  },
  methods: {
    f_unsubscribe: function () {
      let query = '&campaignmail_unsubscribe_code=' + this.d_queryUnsubscribeCode;
      let data = {};
      ServiceFunctions.campaignmail_unsubscribe(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_approveInfoType = 'unsubscribe_completed';
          } else {
            this.d_approveInfoType = 'unsubscribe_not_accepted';
          }
        });
    },
  },
  watch: {}
}

</script>

<style type="text/css">

</style>

